var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buttonwithcheckmark" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: { hover: true },
          },
        ],
        staticClass: "bg-white rounded py-3 px-4 mb-2 soft-shadow clickable",
        class: {
          "border border-success": _vm.active === true,
          "disable-button-with-checkmark": _vm.disable === true,
        },
        attrs: { title: _vm.hoverText },
        on: {
          click: function ($event) {
            return _vm.emitClick()
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "d-flex align-items-center w-100" },
          [
            _c("b-icon", {
              staticClass: "mr-4",
              attrs: {
                icon: _vm.active === true ? "check" : "plus",
                "font-scale": "1.4",
                variant: _vm.active === true ? "success" : "black",
              },
            }),
            _c(
              "div",
              { staticClass: "d-flex flex-column text-left w-100" },
              [
                _c(
                  "div",
                  {
                    staticClass: "text text-wrap capitalize-first w-100",
                    class: _vm.isOneLine === true ? "one-line pr-5" : "",
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _vm._t("default"),
              ],
              2
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }